import { MultiAudioSource } from '@tikka/player/multi-audio-source';

const audioSourceKeySortOrder = ['audioUrl'];
const DEFAULT_SOURCE_KEY = 'audioUrl';

export function createAudioSource() {
  return new MultiAudioSource(audioSourceKeySortOrder, DEFAULT_SOURCE_KEY);
}
